import { useState } from "react";

const useCarousel = (imagesLength: number) => {
  const [carouselImageIndex, setCarouselImageIndex] = useState(0);
  const next = () => {
    setCarouselImageIndex((carouselImageIndex + 1) % imagesLength);
  };
  const prev = () => {
    if (carouselImageIndex === 0) {
      setCarouselImageIndex(imagesLength - 1);
    } else {
      setCarouselImageIndex((carouselImageIndex - 1) % imagesLength);
    }
  };

  return { carouselImageIndex, setCarouselImageIndex, next, prev };
};

export default useCarousel;
